/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './utils/sentry';
import { CKEditor5Builder } from '../src';

ReactDOM.createRoot( document.getElementById( 'root' )! ).render(
	<React.StrictMode>
		<CKEditor5Builder
			locationOrigin={ window.location.origin }
			previewLocation={ './preview.html' }
		/>
	</React.StrictMode>
);
